import React from 'react'
import Layout from '../../components/Layout'
import GridTable from '../../components/GridTable'
import { COLUMNS } from './constants';
import { MODULES } from '../../utils/constants';
import { useCompanyStore } from '../../services/company';
import { usePushNotificationStore } from '../../services/pushNotifications';
import AddNotificationDialog from './AddNotificationDialog';


const PushNotificationGrid = () => {
    const { data, totalPages, currentPage, total, filters, isLoading, fetchGrid, setFilters, nextPage, prevPage, onPageChange, onDelete } = usePushNotificationStore();
    const { globalCompanyId } = useCompanyStore();

    React.useEffect(() => {
        if (globalCompanyId) {
            setFilters({ company_id: globalCompanyId } as any);
        } else {
            fetchGrid();
        }
    }, [globalCompanyId, setFilters, fetchGrid])

    return (
        <Layout appBarTitle="Offers">
            <Layout.Header component={AddNotificationDialog} />
            <Layout.Body
                component={GridTable}
                props={{
                    data,
                    columns: COLUMNS,
                    currentPage,
                    totalPages,
                    total,
                    loading: isLoading,
                    onPageChange,
                    module: MODULES.OFFER,
                    onDelete: (data: any) => onDelete(data._id)
                }}
            />


        </Layout>
    )
}

export default PushNotificationGrid